import React from 'react';

type Props = {
  children: React.ReactNode;
  aside?: React.ReactNode;
};

/** Desktop: main fields left, templates/sources right. Mobile: stacked. */
export default function WizardFormLayout({ children, aside }: Props) {
  return (
    <div className="wizard-form-columns">
      <div className="wizard-form-main">{children}</div>
      {aside ? <div className="wizard-form-aside">{aside}</div> : null}
    </div>
  );
}
